import { useTranslation } from 'react-i18next';

import {
  DrawerType,
  useActionDrawer,
} from '@packages/components/action-drawer/action-drawer-context';
import {
  Typography,
  Stack,
  LinkRouter,
  Button,
} from '@packages/fenrir/components';

import { ListMore } from './list-more';

export interface ListWithDrawerProps {
  title: string;
  list: string[];
  type?: 'text' | 'link';
  maxVisible?: number;
}

export const ListWithDrawer = (props: ListWithDrawerProps) => {
  const { t } = useTranslation('riskManagement', {
    keyPrefix: 'risks',
  });
  const { openDrawer } = useActionDrawer();
  const { title, list, maxVisible = 2, type = 'text' } = props;

  if (list.length === 0) {
    return null;
  }

  const visibleItems = list.slice(0, maxVisible);
  const remainingCount = Math.max(0, list.length - maxVisible);

  return (
    <Stack spacing={1} sx={{ alignItems: 'flex-start' }}>
      {visibleItems.map((item) =>
        type === 'link' ? (
          <LinkRouter to={item} key={item} isExternal>
            <Typography variant="body2">{item}</Typography>
          </LinkRouter>
        ) : (
          <Typography key={item} variant="body2">
            {item}
          </Typography>
        ),
      )}

      {remainingCount > 0 && (
        <Button
          sx={{ mx: 0, px: 0 }}
          variant="text"
          onClick={() =>
            openDrawer(<ListMore title={title} list={list} type={type} />, {
              drawerType: DrawerType.FULL_HEIGHT_DRAWER,
            })
          }
        >
          {t('viewMore', { count: remainingCount })}
        </Button>
      )}
    </Stack>
  );
};
